module.exports = __webpack_public_path__ + "img/form-call.909ba122.svg";